import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 8,
  },
  icon: {
    cursor: "pointer",
    marginLeft: theme.spacing(1),
    fill: "none",
        width: "auto",
        height: "auto",
  },
  infoRow: {
    display: "flex",
    gap: 8,
    marginTop: theme.spacing(1),
  },
  signatureBox: {
    height: 100,
    backgroundColor: "#f5f5f5",
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px dotted #bdbdbd",
  },
  commentBox: {
    height: 100,
    borderRadius: 2,
    padding: theme.spacing(1),
    border: "1px solid #bdbdbd",
    maxHeight: 120, // or any value you prefer
    overflow: "auto",
    width: "100%",
  },
  paper: {
    flex: 1,
  },
}));

export default useStyles;